import { ContainerStatusEnum } from "@gtpl/shared-models/common-models";
import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { ContainerLogBook } from "../container-log-book/container-log-book.entity";
@Entity('log_book_items')
export class LogBookItems {

    @PrimaryGeneratedColumn("increment", { name: 'log_book_item_id' })
    logBookItemId: number;

    @Column("int", {
        nullable: true,
        name: "container_log_book_id"
        })
        containerLogBookId: number;
    @Column("varchar", {
        nullable: true,
        length: 50,
        name: "row"
      })
      row: string;

    @Column("int", {
    nullable: true,
    name: "sale_order_item_id"
    })
    saleOrderItemId: number;

    @Column("int", {
        nullable: true,
        name: "brand_id"
        })
        brandId: number;
        
    @Column("int",{
        nullable:false,
        name:"cartons"
        })
        cartons:number;
        @Column("int",{
            nullable:false,
            name:"unit_id",
            })
        unitId:number;
    @Column("boolean",{
        nullable:false,
        default:true,
        name:"is_active"
        })
        isActive:boolean;
        
    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;


    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    @ManyToOne(type => ContainerLogBook, logBook => logBook.logBookInfo, { nullable: false, })
    @JoinColumn({ name: "container_log_book_id" })
    containerlogBookInfo: ContainerLogBook;
}